// Line Items API endpoints

import apiClient from './client';

export const itemsAPI = {
  /**
   * Get all items
   * @returns {Promise}
   */
  getAll: () => apiClient.get('/items'),

  /**
   * Get single item
   * @param {number} id - Item ID
   * @returns {Promise}
   */
  getById: (id) => apiClient.get(`/items/${id}`),

  /**
   * Create single item
   * @param {Object} data - Item data
   * @returns {Promise}
   */
  create: (data) => apiClient.post('/items', data),

  /**
   * Create multiple items in a single request.
   * The backend's POST /items accepts a JSON array body and creates every item in one call.
   * @param {Array} items - Array of item data objects
   * @returns {Promise}
   */
  createBulk: (items) => apiClient.post('/items', items),

  /**
   * Update item
   * @param {number} id - Item ID
   * @param {Object} data - Item data
   * @returns {Promise}
   */
  update: (id, data) => apiClient.patch(`/items/${id}`, data),

  /**
   * Delete item
   * @param {number} id - Item ID
   * @returns {Promise}
   */
  delete: (id) => apiClient.delete(`/items/${id}`)
};
